import { render } from "./PreLoader.vue?vue&type=template&id=7d630bd9&scoped=true&lang=pug"
const script = {}

import "./PreLoader.vue?vue&type=style&index=0&id=7d630bd9&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d630bd9"]])

export default __exports__